export class Register {
    public CustomerGroup: string;
    public CustomerType: string;
    public RagSoc: string;
    public Piva: string;
    public CF: string;
    public Name: string;
    public SubName: string;
    public Address: string;
    public City: string;
    public Prov: string;
    public Cap: string;
    public Telephone: string;
    public EmailRegister: string;
    public EmailRepeat: string;
    public PecEmail: string;
    public CodiceDestinatario: string;
    public Password: string;
    public PasswordRepeat: string;
    public Newsletter: string;
    public Mobile: string;
    public Language: string;
    public AddressNumber: string;
    public IsCompletedRegistration: any;
    public CartId: any;
    public IsQuickRegistered: boolean;
}

export class QuickRegister {
    EmailRegister: string = '';
    EmailRepeat: string = '';
    Password: string = '';
    PartitaIva: string = '';
    CodiceFiscale: string = '';
    Telephone: string = '';
    CustomerGroup: string = '5'
    info_privacy: string = '';
    Newsletter: any;
    IsQuickRegistered: boolean = false;

    constructor(email: string = '', emailRepeat: string = '', password: string = '', 
                telephone: string = '', customerGroup: string = '5', CF: string = '', PIVA: string = '', oldGroup: string = '5')
    {
        this.CustomerGroup = customerGroup;
        this.controlFormReset(oldGroup, CF, PIVA);
        this.EmailRegister = email;
        this.EmailRepeat = emailRepeat;
        this.Password = password;
        this.Telephone = telephone;
    }

    //-- If client type is changed inside of form from societa to dita individuale, we don't want to reset a PIVA field value also
    //-- If client type is changed inside of form from privato to associazione, we don't want to reset a CF field value also
    controlFormReset(oldGroup, CF, PIVA)
    {
        if(((this.CustomerGroup === '5' || this.CustomerGroup === '6') && (oldGroup === '5' || oldGroup === '6')))
            this.PartitaIva = PIVA;
        else
            this.PartitaIva = ''

        if(((this.CustomerGroup === '4' || this.CustomerGroup === '7') && (oldGroup === '4' || oldGroup === '7')))
            this.CodiceFiscale = CF;
        else
            this.CodiceFiscale = ''
    }
}


// WEBPACK FOOTER //
// ./src/../~/angular2-template-loader!./src/+app/models/cms/register.ts